export default API => ({
    //获取职位基本信息
    findById(data) {
        return API({
            url:`/company/v1/stu/position/findById?id=${data.id}`,
            method:'get',
            data
        });
    },
    //获取公司基本信息
    companyInfoWithoutMan(data) {
        return API({
            url:`/company/v1/candidate/companyInfo/companyInfoWithoutMan?companyId=${data.companyId}`,
            method:'get',
            data
        });
    },
    //相似招聘列表
    findSimilarPostion(data) {
        return API({
            url:`/company/v1/stu/position/findSimilarPostion` ,
            method:'post',
            data
        });
    },
})
